import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { jsonToQueryString } from '@/utils'
import { PlayerCardActionTypes } from '../constants'
import { PlayerCardState } from '../models'

import { PLAYER_CARD } from './api.routes'
import { PlayerCardModels } from '../'

const apiService: RestApiService = Container.get(RestApiService)

export const getPlayerThunk = createAsyncThunk(
  PlayerCardActionTypes.GET_PLAYER,
  async (payload: string, thunkAPI) => {
    const { auth } = thunkAPI.getState() as ApplicationState

    try {
      apiService.requestParams = {
        method: 'GET',
        endpoint: `${PLAYER_CARD.GET_PLAYERS}/${payload}`,
        queries: jsonToQueryString({
          brandId: auth.brand.siteId.toString(),
          //brandId: 'f1c808ad-dda5-4aa5-8553-63f99562ad05',
        }),
        isIncentiveAPI: true,
      }

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: PlayerCardModels.GetPlayerCardResponse =
        await apiService.getData(auth.brand.siteId.toString(), auth.token)

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

export const getPlayerExtraReducer = (
  builder: ActionReducerMapBuilder<PlayerCardState>,
) => {
  builder.addCase(getPlayerThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(getPlayerThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
    state.playerCard = payload
  })
}
